import Header from './Header';

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.site-header');
  if (header) {
    new Header(header);
  }
});
